import { ICreateProjectRequest } from "../entities-generated/models/project/create-project-request";
import { IStormDoorModel } from "../entities-generated/models/storm-door/storm-door-model";
import { AuthApiClient } from "./auth-api-client";

class BrowseApiClientClass {
  public getStormDoorCatalog() {
    return AuthApiClient.get<IStormDoorModel[]>(`browse/storm-doors`);
  }

  public createNewProject(request: ICreateProjectRequest) {
    return AuthApiClient.post<void>(`browse/request-measurement`, request);
  }
}

export const BrowseApiClient = new BrowseApiClientClass();